export enum EventsNames {
  sampleIp = 'Sample IP',

  // Old Events
  ChooseYourPlan = 'ChooseYourPlan',
  ErrorChangeAmount = 'ErrorChangeAmount',
  ErrorChangeDownPayment = 'ErrorChangeDownPayment',
  EmailVerificationContinueToCheckout = 'EmailVerificationContinueToCheckout',
  EmailVerificationAgeError = 'EmailVerificationAgeError',
  EmailVerificationMissingSSN = 'EmailVerificationMissingSSN',
  EmailVerificationError = 'EmailVerificationError',
  EmailVerificationResend = 'EmailVerificationResend',
  EmailVerificationSendVerification = 'EmailVerificationSendVerification',
  LandingPage = 'LandingPage',
  PhoneVerificationLand = 'PhoneVerificationLand',
  PaymentDetails = 'PaymentDetails',
  CustomerDetails = 'CustomerDetails',
  CustomerDetailsReturningCustomer = 'CustomerDetailsReturningCustomer',
  CustomerDetailsNew = 'CustomerDetailsNew',
  PhoneVerificationFailure = 'PhoneVerificationFailure',
  PhoneVerificationSuccess = 'PhoneVerificationSuccess',
  PhoneVerificationSent = 'PhoneVerificationSent',
  NewPurchase = 'NewPurchase',
  BeforeExtraVerification = 'Before Extra Verification',
  ExtraVerificationPageLoad = 'Extra Verification Page Load',
  AfterExtraVerification = 'After Extra Verification',
  HealthcareNotice = 'Healthcare Notice',

  // Mx Events
  MxFlowStarted = 'Start Mx Flow',
  MxConsentView = 'Mx Consent View',
  MxHigherAmountApprovedView = 'Mx Higher Amount Approved View',
  MxHigherAmountUnapprovedView = 'Mx Higher Amount Unapproved View',
  MxLoadingView = 'Mx Loading View',
  MxTechnicalErrorView = 'Mx Technical Error View',
  MxConnectedToAccount = 'Mx Connected With Bank Account',
  MxPresented = 'Mx Presented To Client',
}
